<style lang="scss" scoped>
.accordion {
  margin-bottom: 30px;
}

.managementbutton {
  margin-top: 30px;
}

.padding-tb {
  padding-top: 10px;
  padding-bottom: 10px;
}

.outer-file-list {
  //border: 1px solid $c-dark-gray;
  padding: 15px;
  margin: 20px 0;
}
</style>

<template>
  <div class="row mt-3 align-items-center mb-1" v-if="type != 'personal' && !simple">
    <div class="col-12">
      <h3>{{ overviewHeader }} Overview</h3>
    </div>
  </div>

  <div class="row mt-4 mb-3">
    <div class="col-12">
      <Legend :withTarget="type == 'personal'" horizontal />
    </div>
  </div>

  <div class="row align-items-center mb-1 padding-tb" v-if="type != 'personal'">
    <div class="col-md-10 col-xs-12">
      <h3>Übersicht {{ tableHeader }}</h3>
    </div>
    <div class="col-xs-12 col-md-2">
      <button @click="compareClick">Filter</button>
      <CompareDialogue :open="compareOpen" @close="compareClose" :type="type" :unit="unit" />
    </div>
  </div>

  <div class="row">
    <div class="col-12" id="personal">
      <SkillTableAccordion :name="name" :skills="personal" :title="$t('skills.personal')" :type="type" :unit="unit" group="personal" />
    </div>
    <div class="col-12" id="social">
      <SkillTableAccordion :name="name" :skills="social" :title="$t('skills.social')" :type="type" :unit="unit" group="social" />
    </div>
    <div class="col-12" id="working">
      <SkillTableAccordion :name="name" :skills="working" :title="$t('skills.professional')" :type="type" :unit="unit" group="working" />
    </div>
  </div>

  <div class="row">
    <div class="col-8" v-if="type == 'personal'">
      <EntwicklungsPlan :unit="unit" />
      <div class="outer-file-list" v-if="files.length > 0">
        <h3 v-if="files.length > 0">Dateien</h3>
        <FileList :files="files" v-if="files.length > 0" />
      </div>
      <div class="outer-file-list" v-hasperms="['user.all.manage', 'user.unit.manage', 'user.allbutceo.manage']">
        <h3>Projektzusammenarbeiten</h3>
        <Zusammenarbeit :user="unit" />
      </div>
    </div>
    <div class="col-4" :class="{ 'offset-8': type != 'personal' }">
      <Legend :withTarget="type == 'personal'" noheader />
    </div>
  </div>
  <div class="row"></div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue';
import { useStore } from 'vuex';

import CompareDialogue from './CompareDialogue.vue';

import EntwicklungsPlan from './EntwicklungsPlan.vue';
import FileList from './FileList.vue';
import Zusammenarbeit from './custom/Zusammenarbeit.vue';

export default defineComponent({
  props: {
    type: { type: String, default: 'personal' },
    unit: { type: Number },
    name: { type: String, default: '' },
    simple: { type: Boolean, default: false },
  },
  components: {
    CompareDialogue,

    EntwicklungsPlan,
    FileList,
    Zusammenarbeit,
  },
  setup(props) {
    const store = useStore();
    const compareOpen = ref(false);
    const overviewHeader = ref('');
    const tableHeader = ref('');
    const files = ref<Array<number>>([]);

    const compareClick = () => {
      compareOpen.value = true;
    };

    const compareClose = () => {
      compareOpen.value = false;
    };

    switch (props.type) {
      case 'unit':
        store.dispatch('fetchSkillsForUnit', props.unit);
        overviewHeader.value = 'Unit';
        tableHeader.value = 'Mitarbeiter:innen';
        //store.dispatch('fetchUnitGrades', props.unit);
        break;
      case 'company':
        // store.dispatch('fetchOverviewGrades');
        store.dispatch('fetchSkills');
        overviewHeader.value = 'Company';
        tableHeader.value = 'Abteilungen';
        // store.dispatch('fetchCompanyGrades');
        break;
      case 'personal':
        store.dispatch('fetchUserData', props.unit).then((res: any) => {
          files.value = JSON.parse(res.files);
          store.dispatch('fetchSkillsForUnit', res.unit_id);
        });
        break;
    }

    const social = computed(() => store.getters.getSocialSkills || false);
    const working = computed(() => store.getters.getWorkingSkills || false);
    const personal = computed(() => store.getters.getPersonalSkills || false);

    return {
      working,
      social,
      personal,
      overviewHeader,
      tableHeader,
      compareOpen,
      compareClick,
      compareClose,
      files,
    };
  },
});
</script>
